import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BryAuthService {

 private readonly TOKEN_KEY = 'bry_token';
  private readonly EXP_KEY = 'bry_token_expiration';
  private readonly AUTH_URL = 'https://cloud.bry.com.br/token-service/jwt';

  private readonly CLIENT_ID = environment.clientIdBry;
  private readonly CLIENT_SECRET = environment.secretKeyBry;

  constructor(private http: HttpClient) {}

  async getToken(): Promise<string> {
    const token = localStorage.getItem(this.TOKEN_KEY);
    const exp = parseInt(localStorage.getItem(this.EXP_KEY) || '0', 10);
    const now = Date.now();

    if (token && now < exp) return token;

    return this.fetchNewToken();
  }

  private async fetchNewToken(): Promise<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('client_id', this.CLIENT_ID)
      .set('client_secret', this.CLIENT_SECRET);

    const response: any = await this.http
      .post(this.AUTH_URL, body.toString(), { headers })
      .toPromise();

    const accessToken = response.access_token;
    const expiresIn = response.expires_in;

    const expirationTime = Date.now() + expiresIn * 1000;

    localStorage.setItem(this.TOKEN_KEY, accessToken);
    localStorage.setItem(this.EXP_KEY, expirationTime.toString());

    return accessToken;
  }
}
